import { ReactNode } from 'react';
import { SkeletonTitle, SkeletonText, WithSkeleton } from './Skeleton';
import { twMerge } from 'tailwind-merge';

type CardType = {
  isLoading?: boolean;
  skeleton?: ReactNode;
} & React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
>;

export default function Card({
  className,
  children,
  isLoading,
  skeleton,
  ...props
}: CardType) {
  const skeletonCard = skeleton ?? (
    <>
      <SkeletonTitle />
      <SkeletonText />
      <SkeletonText />
    </>
  );

  const classname = twMerge(
    'p-5 rounded-xl bg-white border border-gray-200 hover:border-gray-300 transition-all',
    className
  );

  return (
    <div className={classname} {...props}>
      <WithSkeleton isLoading={!!isLoading} skeleton={skeletonCard}>
        {children}
      </WithSkeleton>
    </div>
  );
}
